

































































































































































































































































































































































































import { Usuario } from "@/services/home.service";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Menu extends Vue {
  @Prop({ default: null }) readonly usuario!: Usuario | null;
}
